<template>
  <div class="allApps">
    <div class="allApps-box-wrapper">
      <div class="allApps-box">
        <!-- 探索类别 -->
        <div class="search-hot-category">
          <div class="search-hot-title">
            {{ $t("home.explore.hot.categories") }}
          </div>
          <div class="search-hot-content">
            <div class="hot-tag" v-for="(tag, key) in hotTags" :key="key">
              <el-tag
                style="cursor: pointer"
                effect="plain"
                @click="handleTagClick(tag.value)"
                >{{ $t(tag.label) }}</el-tag
              >
            </div>
          </div>
        </div>
        <!-- 导航栏 -->
        <NavigationBanner />
        <!-- 应用列表 -->
        <AppList :appListData="appListData" />
        <!-- 安装次数 -->
        <div class="install-stats">
          <div class="stats-icon">
            <svg
              viewBox="0 0 24 24"
              fill="currentColor"
              class="stats-chart-icon"
            >
              <path d="M5 9.2h3V19H5zM10.6 5h2.8v14h-2.8zm5.6 8H19v6h-2.8z" />
            </svg>
          </div>
          <div class="stats-content">
            <div class="stats-text">
              <span class="stats-label">{{ $t("home.stats.total") }}</span>
              <span class="stats-number">{{ productTotal }}</span>
              <span class="stats-label">{{
                $t("home.stats.industry.products")
              }}</span>
              <span class="stats-number">{{ trialTotal }}</span>
              <span class="stats-label">{{ $t("home.stats.times") }}</span>
            </div>
            <div class="stats-decoration">
              <span class="decoration-dot"></span>
              <span class="decoration-dot"></span>
              <span class="decoration-dot"></span>
            </div>
          </div>
          <div class="stats-glow"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AppMarketApi from "@/utils/requestList.js";
import NavigationBanner from "./components/NavigationBanner.vue";
import AppList from "./components/AppList.vue";
import { industryOptionNew } from "@/utils/resource.js";

export default {
  name: "index",
  components: {
    NavigationBanner,
    AppList,
  },
  computed: {
    hotTags() {
      // 取对象里的前10个
      const keys = Object.keys(industryOptionNew).slice(0, 9);
      return keys.map((key) => industryOptionNew[key]);
    },
  },
  data() {
    return {
      //应用列表分类显示
      appListData: [],
      // 产品个数
      productTotal: 0,
      // 试用产品个数
      trialTotal: 0,
    };
  },
  methods: {
    // 初始化应用市场分组数据 - 显示固定的两个模块：赞助解决方案和今日趋势
    async initGroupList() {
      // 创建固定的两个模块数组
      let fixedData = [];
      
      Promise.all([
        AppMarketApi.getInstance().getRecommendedProducts({}),
        AppMarketApi.getInstance().getTheLastestProducts({}),
        AppMarketApi.getInstance().getStatisticalQuantity({}),
      ])
        .then((res) => {
          if (res[0].result && res[0].data.length > 0) {
            fixedData.push({ key: "sponsoredSolutions", data: res[0].data });
          }
          if (res[1].result && res[1].data.length > 0) {
            fixedData.push({ key: "todayTrends", data: res[1].data });
          }
          if (res[2].result && res[2].data) {
            this.productTotal = res[2].data.productTotal;
            this.trialTotal = res[2].data.trialTotal;
          }
          this.appListData = fixedData;
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        });
    },
    // 行业
    handleTagClick(tag) {
      // 存储行业参数到localStorage
      localStorage.setItem("selectedIndustry", tag);
      localStorage.setItem("isFromIndustryTag", "true");

      // 跳转到应用页面
      this.$router.push({
        path: "/allApps",
      });

      setTimeout(() => {
        this.$bus.$emit("updateHeaderActiveIndex", "1");
        // 发送事件通知FilterCondition组件展开行业折叠面板并选中对应项
        this.$bus.$emit("selectIndustry", tag.toString());
      }, 300);

      this.$emit("handleTagClick", tag);
    },
  },
  mounted() {
    this.initGroupList();
  },
};
</script>

<style lang="scss" scoped>
.allApps {
  height: 100%;
  background: #fff;
  overflow: hidden;
  display: flex;
  flex-direction: column;

  .allApps-box-wrapper {
    width: 100%;
    flex: 1;
    display: flex;
    justify-content: center;
    overflow-y: auto;

    .allApps-box {
      width: 90%;
      max-width: 1200px;
      min-width: 320px;
      margin: 0 auto;

      .search-hot-category {
        margin-top: 8px;
        padding-bottom: 15px;

        .search-hot-title {
          font-size: 18px;
          font-weight: bold;
          margin-bottom: 15px;
          color: #0e2a5e;
        }

        .search-hot-content {
          display: flex;
          flex-wrap: wrap;
          gap: 10px;

          ::v-deep .el-tag--plain {
            border-color: #043c7b;
            color: #043c7b;
          }
        }
      }

      .install-stats {
        background: linear-gradient(
          135deg,
          #193250 0%,
          #2d4a6b 50%,
          #1a3251 100%
        );
        color: white;
        text-align: center;
        padding: 12px 20px;
        border-radius: 12px;
        margin: 15px;
        position: relative;
        overflow: hidden;
        box-shadow: 0 8px 32px rgba(25, 50, 80, 0.3);
        border: 1px solid rgba(255, 255, 255, 0.1);
        backdrop-filter: blur(10px);
        transition: all 0.3s ease;

        &:hover {
          transform: translateY(-2px);
          box-shadow: 0 12px 40px rgba(25, 50, 80, 0.4);
        }

        .stats-icon {
          position: absolute;
          top: 10px;
          left: 15px;
          opacity: 0.3;

          .stats-chart-icon {
            width: 20px;
            height: 20px;
            color: #61dafb;
          }
        }

        .stats-content {
          position: relative;
          z-index: 2;

          .stats-text {
            font-size: 16px;
            font-weight: 600;
            margin-bottom: 4px;
            text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
            line-height: 1.4;
            flex-wrap: wrap;
            justify-content: center;
            align-items: baseline;
            gap: 4px;

            .stats-label {
              color: #e8f4fd;
              font-weight: 400;
              font-size: 16px;
            }

            .stats-number {
              color: #61dafb;
              font-weight: 800;
              font-size: 28px;
              text-shadow: 0 0 10px rgba(97, 218, 251, 0.5);
              background: linear-gradient(135deg, #61dafb, #21d4fd);
              -webkit-background-clip: text;
              -webkit-text-fill-color: transparent;
              background-clip: text;
              position: relative;
              margin: 0 2px;
              animation: numberGlow 2s ease-in-out infinite alternate;

              &::before {
                content: attr(data-number);
                position: absolute;
                top: 0;
                left: 0;
                color: rgba(97, 218, 251, 0.3);
                z-index: -1;
                filter: blur(2px);
              }
            }
          }

          .stats-decoration {
            display: flex;
            justify-content: center;
            gap: 8px;
            margin-top: 6px;

            .decoration-dot {
              width: 6px;
              height: 6px;
              border-radius: 50%;
              background: linear-gradient(45deg, #61dafb, #21d4fd);
              opacity: 0.8;
              animation: pulse 2s infinite;

              &:nth-child(2) {
                animation-delay: 0.3s;
              }

              &:nth-child(3) {
                animation-delay: 0.6s;
              }
            }
          }
        }

        .stats-glow {
          position: absolute;
          top: 50%;
          right: -50px;
          width: 100px;
          height: 100px;
          background: radial-gradient(
            circle,
            rgba(97, 218, 251, 0.2) 0%,
            transparent 70%
          );
          border-radius: 50%;
          transform: translateY(-50%);
          animation: float 4s ease-in-out infinite;
        }

        &::before {
          content: "";
          position: absolute;
          top: 0;
          left: -100%;
          width: 100%;
          height: 100%;
          background: linear-gradient(
            90deg,
            transparent,
            rgba(255, 255, 255, 0.1),
            transparent
          );
          animation: shimmer 3s infinite;
        }

        @media (max-width: 768px) {
          .stats-content {
            .stats-text {
              font-size: 14px;
              flex-direction: column;
              text-align: center;

              .stats-number {
                font-size: 24px;
                margin: 4px 0;
              }

              .stats-label {
                font-size: 14px;
              }
            }
          }

          .stats-icon .stats-chart-icon {
            width: 20px;
            height: 20px;
          }
        }
      }

      @keyframes pulse {
        0%,
        100% {
          opacity: 0.4;
          transform: scale(1);
        }
        50% {
          opacity: 1;
          transform: scale(1.2);
        }
      }

      @keyframes numberGlow {
        0% {
          text-shadow: 0 0 10px rgba(97, 218, 251, 0.5);
        }
        100% {
          text-shadow: 0 0 20px rgba(97, 218, 251, 0.8),
            0 0 30px rgba(97, 218, 251, 0.4);
        }
      }

      @keyframes float {
        0%,
        100% {
          transform: translateY(-50%) translateX(0);
        }
        50% {
          transform: translateY(-50%) translateX(10px);
        }
      }

      @keyframes shimmer {
        0% {
          left: -100%;
        }
        100% {
          left: 100%;
        }
      }
    }
  }
}
</style>
